import React from 'react';
import { sendAutofillMessage } from '../../utilities/autofill';
import CreditCardNumber from './credit-card-number';
import CardExpirationDate from './card-expiration-date';
import CardSecurityCode from './card-security-code';
import SimpleText from './simple-text';

const filePaths = {
  CreditCardNumber: CreditCardNumber,
  CardExpirationDate: CardExpirationDate,
  CardSecurityCode: CardSecurityCode,
  CardHolderName: SimpleText,
};

const HiddenComponents = ({ hiddenComponents }) => {
  return (
    <>
      {Object.entries(hiddenComponents).map(([name, componentProps], index) => {
        const HiddenComponent = filePaths[name];
        const key = index + 1;
        return (
          <HiddenComponent
            key={key}
            className="hidden-field"
            tabIndex="-1"
            hiddenField={true}
            onChange={(e) => sendAutofillMessage(e.target, e.target.value)}
            {...componentProps}
          />
        );
      })}
    </>
  );
};

export default HiddenComponents;
